import * as React from "react";

import CountDown from "../CountDown";
import { DoubleCardWrap } from "../styles.card";
import { ProductCardProps } from "./index";

import { BannerContainer } from "../../../../components/BannerContainer";
import { ProductInfoGrid2 } from "../../../LayerUI/ProductInfoViews";
import { ProductImageTagViews } from "../../../LayerUI/ImageTagViews";
import { LinkTargetType } from "../../../../services/playground";
import { transformAParam } from "utils/browser";
import { PoolExtraInfo } from "../../../../services/product";

const DoubleCard = (props: ProductCardProps) => {
	const {
		productElement,
		stylesForCard = {},
		columnNum,
		layoutStyle,
		placeholderBg,
		qnParams = {},
		isInApp,
		collectOptions = {},
		displayInfo,
		poolId,
		isRollable,
		runtime,
	} = props;
	const {
		imgOnBottomLeft,
		imgOnTopLeft,
		imgOnTopLeft2,
		imgOnTopRight,
		titleIcon,
		collect,
		actTags,
		flash,
	} = productElement.extra || ({} as PoolExtraInfo);

	const aProps = transformAParam({
		isInApp: !!isInApp,
		link: productElement.url,
		aTarget: LinkTargetType.Blank,
		onClick: props.onClick,
		isProductWrap: true,
		runtime,
	});

	return (
		<DoubleCardWrap isRollable={isRollable} {...aProps} id={`${poolId}${productElement.gpid}`}>
			<BannerContainer
				banner={{
					img: productElement.img,
					link: productElement.url,
				}}
				style={{
					...stylesForCard,
				}}
				className={"productPictureWrap"}
				placeholderBg={placeholderBg}
				qnParams={{ ...qnParams }}
				keepSize={true}
			>
				<ProductImageTagViews
					columnNum={2}
					rightTopTag={imgOnTopRight}
					leftTopTag={imgOnTopLeft}
					leftTopTag2={imgOnTopLeft2}
					leftBottomTag={imgOnBottomLeft}
					isOnlyShowLeftTopTag={isRollable}
				/>
				{flash?.countdownToEnd && (
					<CountDown
						countInfo={flash}
						needIcon={!isRollable}
						needEndsIn={!isRollable}
						needIconImg={isRollable}
					/>
				)}
			</BannerContainer>

			<ProductInfoGrid2
				columnNum={columnNum || 2}
				price={productElement.price}
				originPrice={productElement.originPrice}
				name={productElement.name}
				titleIcon={titleIcon?.img}
				collect={collect}
				collectOptions={collectOptions}
				actTags={actTags}
				layoutStyle={layoutStyle}
				displayInfo={displayInfo}
				priceCurrency={productElement.priceCurrency}
				originPriceCurrency={productElement.originPriceCurrency}
				priceSymbol={productElement.priceSymbol}
				originPriceSymbol={productElement.originPriceSymbol}
			/>
		</DoubleCardWrap>
	);
};

export default DoubleCard;
